import { render, staticRenderFns } from "./prizeAdd.vue?vue&type=template&id=681c07cd&scoped=true&"
import script from "./prizeAdd.vue?vue&type=script&lang=js&"
export * from "./prizeAdd.vue?vue&type=script&lang=js&"
import style0 from "./prizeAdd.vue?vue&type=style&index=0&id=681c07cd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681c07cd",
  null
  
)

export default component.exports